(function (quoteView, $) {
  var quoteIndex = 0;
  var quotes;
  var inspirationalQuoteHolder;
  var elQuoteType;
  var elQuote;
  var elQuotee;

  quoteView.init = function () {
    inspirationalQuoteHolder = $("#keep-going-holder");
    elQuoteType = $("#keep-going-quote-type");
    elQuote = $("#keep-going-quote");
    elQuotee = $("#keep-going-quotee");

    quotes = [
      {
        quoteType: "",
        quote: "Today me will live in the moment unless it's unpleasant in which case me will eat a cookie",
        quotee: "Cookie Monster",
      },
      {
        quoteType: "Sacrilegious",
        quote: "But Marge, what if we chose the wrong religion? Each week we just make God madder and madder.",
        quotee: "Homer Simpson",
      },
      {
        quoteType: "Tech",
        quote: "&ldquo;To Start Press Any Key&rdquo;. Where's the ANY key!?",
        quotee: "Homer Simpson",
      },
      {
        quoteType: "Profound",
        quote:
          "I didn't want to change society. I wanted to give society a chance to determine if it should change itself",
        quotee: "Edward Snowden",
      },
      { quoteType: "Inspirational", quote: "Do epic shit", quotee: "" },
      { quoteType: "Canibal", quote: "You are what you eat, I'm a man", quotee: "Dr. Hannibal Lecter" },
      {
        quoteType: "Inspirational",
        quote: "First they ignore you, then they laugh at you, then they fight you, then you win",
        quotee: "Mahatma Gandhi",
      },
      {
        quoteType: "Sports",
        quote: "It took me 17 years and 114 days to become an overnight success",
        quotee: "Lionel Messi",
      },
      { quoteType: "Motivational", quote: "Quit slackin' and make shit happen", quotee: "" },
      { quoteType: "Design", quote: "I want to make beautiful things, even if nobody cares", quotee: "Saul Bass" },
      { quoteType: "Wise", quote: "New beginnings are often disguised as painful endings...", quotee: "Lao Tzu" },
      { quoteType: "Fashion", quote: "Fashion can be bought. Style one must posess.", quotee: "Edna Woolman Chase" },
      { quoteType: "Inspirational", quote: "Be so good they can't ignore you", quotee: "Steve Martin" },
      { quoteType: "Wise", quote: "I am not young enough to know everything", quotee: "Oscar Wilde" },
      {
        quoteType: "Tech",
        quote: "Any sufficiently advanced technology is indistinguishable from magic",
        quotee: "Arthur C. Clarke",
      },
      {
        quoteType: "Tech",
        quote:
          "A computer would deserve to be called intelligent if it could deceive a human into believing that it was human",
        quotee: "Alan Turing",
      },
      {
        quoteType: "Action Hero",
        quote: "Money doesn't make you happy. I now have $50 million but I was just as happy when I had $48 million.",
        quotee: "Arnold Schwarzenegger",
      },
      { quoteType: "Confidence", quote: "I'm my favourite rapper", quotee: "Kanye West" },
      {
        quoteType: "Motivational",
        quote: "Dude, suckin' at something is the first step towards bein' sorta good at something",
        quotee: "Jake the Dog - Adventure Time",
      },
      { quoteType: "Sports", quote: "Everyone has a plan until they get punched in the mouth", quotee: "Mike Tyson" },
      {
        quoteType: "",
        quote:
          "Dogs look up to you, cats look down on you. Give me a pig. He just looks you in the eye and treats you as an equal.",
        quotee: "Winston Churchill",
      },
      {
        quoteType: "Wise",
        quote: "A master in the art of living draws no true distinction between their work and their play",
        quotee: "Fran&ccedil;ois-Rene Auguste de Chateaubriand",
      },
      {
        quoteType: "Online Dating",
        quote: "I’m just a boy, standing in front of the Internet, asking it to love me.",
        quotee: "Josh 29, Tinder",
      },
      {
        quoteType: "Sartorial",
        quote: "A gentleman can be neither over dressed nor over educated",
        quotee: "Oscar Wilde",
      },
      {
        quoteType: "EX-POTUS",
        quote:
          "Robert Pattinson should not take back Kristen Stewart. She cheated on him like a dog &amp; will do it again - just watch. He can do much better!",
        quotee: "Donald Trump",
      },
      {
        quoteType: "Ancient",
        quote: "Choose a job you love, and you will never have to work a day in your life",
        quotee: "Confucius",
      },
      {
        quoteType: "Pop",
        quote: "You want a hot body? You want a Bugatti? You want a Maserati? You better work bitch.",
        quotee: "Britney Spears",
      },
      { quoteType: "Robot", quote: "Freedom is the right of sentient beings", quotee: "Optimus Prime" },
      { quoteType: "LOL", quote: "Prefer crying in a limo to laughing on a bus", quotee: "John Giorno" },
      {
        quoteType: "Rhyming",
        quote: "Today you are YOU, that is TRUER than true. There is no one alive who is YOUER than YOU.",
        quotee: "Dr. Seuss",
      },
      {
        quoteType: "Science",
        quote: "If I have seen further it is by standing on the shoulders of giants.",
        quotee: "Isaac Newton",
      },
      {
        quoteType: "Wise",
        quote: "Never argue with a fool. Onlookers may not be able to tell the difference.",
        quotee: "Mark Twain",
      },
      {
        quoteType: "Scientist",
        quote: "I have not failed. I have found a thousand ways that won't work.",
        quotee: "Thomas Edison",
      },
      {
        quoteType: "Patriarchy",
        quote:
          "“Traditionally, science fairs are a father-son thing.” “Well, scientifically, traditions are an idiot thing.”",
        quotee: "Rick to Morty",
      },
    ];

    quotes = _.shuffle(quotes);

    inspirationalQuoteHolder.click(randomiseInspirationalQuote);
    randomiseInspirationalQuote(false);
  };

  function randomiseInspirationalQuote(animated) {
    if (typeof animated === "undefined") {
      animated = true;
    }

    var rotateSpeed = animated ? 400 : 0;
    var transitAnim = {};
    if (animated) {
      transitAnim = { rotate: "+=90deg" };
    }

    $("#keep-going-refresh").transit(transitAnim, rotateSpeed, function () {
      if (inspirationalQuoteHolder.hasClass("animated")) {
        return;
      }

      quoteIndex = (quoteIndex + 1) % quotes.length;

      if (!animated) {
        setNextQuote();
        return;
      }

      var animationClasses = "animated fadeOut";

      inspirationalQuoteHolder
        .addClass(animationClasses)
        .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
          inspirationalQuoteHolder.removeClass(animationClasses);

          setNextQuote();

          var hideAnimationClasses = "animated bounceIn";
          inspirationalQuoteHolder
            .addClass(hideAnimationClasses)
            .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
              inspirationalQuoteHolder.removeClass(hideAnimationClasses);
            });
        });
    });
  }

  function setNextQuote() {
    elQuoteType.html(quotes[quoteIndex].quoteType);
    elQuote.html(quotes[quoteIndex].quote);
    elQuotee.html(quotes[quoteIndex].quotee);
  }

  return quoteView;
})((window.el.QuoteView = window.el.QuoteView || {}), jQuery);
